import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon, blue } = colorsPalettes;

export const Container = styled.div<{ isLoading?: boolean; isActive?: boolean }>`
    box-sizing: border-box;
    width: 100%;
    min-width: 250px;

    padding: ${({ isLoading }) => (isLoading ? "16px 16px 10px" : "16px")};
    background: ${carbon[0]};
    border-radius: 4px;
    border: 1px solid ${carbon[50]};

    cursor: ${({ isActive }) => (isActive ? "pointer" : "default")};

    &:hover {
        ${({ isActive }) =>
            isActive &&
            css`
                border: 1px solid ${carbon[100]};
                box-shadow: 0 3px 5px 0 rgba(42, 62, 82, 0.12);

                & .SWReactIcons[data-automation-icon-name="arrow-slant-right"] svg path {
                    fill: ${blue[400]};
                }
            `}
    }

    .keywordChangeIndication {
        width: max-content;
        padding: 4px 12px 4px 8px;

        p {
            ${setFontVariant("h6")}
        }
    }
`;

export const Header = styled(FlexRow)`
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 24px;
`;
